import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type {
	HomepageTopImpactStoriesDataQuery,
	HomepageTopImpactStoriesDataQueryVariables,
} from './homepageTopImpactStories.graphql';
import { HomepageTopImpactStoriesData } from './homepageTopImpactStories.graphql';
import type { TopImpactStoryPetitionData } from './types';

type TopImpactStoriesData = TopImpactStoryPetitionData;

export async function getTopImpactStories(
	utilityContext: UtilityContext,
	{ petitionId }: { locale: string; petitionId: string },
): Promise<TopImpactStoriesData> {
	const {
		gql: { fetch },
	} = utilityContext;
	const { data } = await fetch<HomepageTopImpactStoriesDataQuery, HomepageTopImpactStoriesDataQueryVariables>({
		query: HomepageTopImpactStoriesData,
		variables: { petitionId },
		rejectOnError: false,
	});

	if (!data) {
		// TODO UPDATE THESE
		throw new Error('homepage_impact_stories_data_not_found');
	}

	if (!data.petition) {
		throw new Error('homepage_impact_stories_data_not_found');
	}

	const { petition } = data;

	return {
		id: petition.id,
		slug: petition.slug,
		signatureCount: petition.signatureState.signatureCount.displayedLocalized,
		isVictory: petition.status === 'VICTORY',
	};
}
